var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"network-graph-hc"},[_c('div',{ref:"container",staticClass:"chart-box"})])
}
var staticRenderFns = []

export { render, staticRenderFns }